import axiosInstance from "./config/axios";

/**
 * Validate a coupon code
 * @param {string} code - The coupon code
 * @param {number} subtotal - The cart subtotal
 * @returns {Promise} - Response with coupon details and discount amount
 */
export const validateCoupon = async (code, subtotal) => {
    const response = await axiosInstance.post("/api/coupons/validate", {
        code,
        subtotal,
    });
    return response.data;
};

/**
 * Remove applied coupon (just client-side action)
 * @returns {Promise}
 */
export const removeCoupon = async () => {
    const response = await axiosInstance.post("/api/coupons/remove");
    return response.data;
};

export default {
    validateCoupon,
    removeCoupon,
};
